import React, { useState } from 'react';
import FormControl from '@avtopro/form-control';
import TextInput from '@avtopro/text-input';
import { type CountryCode } from '@avtopro/telephone-input-smart';
import ErrorOutput from '@avtopro/error-output';
import Button from '@avtopro/button';
import { IntrinsicFormProps } from '@avtopro/validator/src/withValidation';
import PhoneInputSmart from '@avtopro/telephone-input-smart/lazy';
import homeResx from 'Resx/Home/Home.resx';
import cartResx from 'Resx/Cart/Cart.resx';

const countryEuIsoList: CountryCode[] = [
    'at',
    'de',
    'be',
    'bg',
    'cy',
    'hr',
    'dk',
    'sk',
    'si',
    'es',
    'ee',
    'fi',
    'fr',
    'gr',
    'hu',
    'ie',
    'it',
    'lv',
    'lt',
    'lu',
    'mt',
    'nl',
    'pl',
    'pt',
    'cz',
    'ro',
    'se'
];

interface BannerFormState {
    name: string | null;
    phoneNumber: string | null;
    phoneData: { exampleNumbers: string[] } | null;
}

const BannerForm = ({ onSubmit, errors }: IntrinsicFormProps): JSX.Element => {
    const [state, setState] = useState<BannerFormState>({
        name: null,
        phoneNumber: '',
        phoneData: null
    });

    const placeholderExampleNumber = state?.phoneData?.exampleNumbers[0];
    const phoneInputPlaceholder = placeholderExampleNumber
        ? cartResx.CartProfileFormPlaceholderPhoneNumber.replace(
              '{0}',
              placeholderExampleNumber
          )
        : cartResx.CartProfileFormPlaceholderPhone;

    const onSubmitCrm = event => {
        event.preventDefault();
        onSubmit(state);
    };

    const onChangeName = event => {
        const { value } = event.target;
        const updater = {
            ...state,
            name: value
        };
        setState(updater);
    };

    const onChangePhone = (
        _: string,
        value: string,
        phoneData: { exampleNumbers: string[] }
    ) => {
        const updater = {
            ...state,
            phoneNumber: value,
            phoneData
        };
        setState(updater);
    };

    return (
        <>
            <div className="modwin__caption">
                {homeResx.BannerStartSalesModalFormTitle}
            </div>
            <div className="modwin__sub-caption">
                {homeResx.BannerStartSalesModalFormSubTitle}
            </div>
            <form className="pro-form" onSubmit={onSubmitCrm}>
                <FormControl>
                    <TextInput
                        id="name"
                        name="name"
                        value={state.name}
                        placeholder={
                            homeResx.BannerStartSalesModalFormNameInputPlaceholder
                        }
                        onChange={onChangeName}
                    />
                    <ErrorOutput
                        modelName=".name"
                        errorResponse={errors}
                        htmlFor="name"
                    />
                </FormControl>
                <FormControl>
                    <PhoneInputSmart
                        id="phoneNumber"
                        name="phoneNumber"
                        defaultValue={state.phoneNumber}
                        onChange={onChangePhone}
                        placeholder={phoneInputPlaceholder}
                        allowedCountries={countryEuIsoList}
                        restrictCountries
                    />
                    <ErrorOutput
                        modelName=".phoneNumber"
                        errorResponse={errors}
                        htmlFor="phoneNumber"
                    />
                </FormControl>
                <div className="pro-form__footer pro-form__footer--mirror">
                    <div className="pro-form__control">
                        <Button type="submit" theme="prime" uppercase>
                            {homeResx.BannerStartSalesModalFormBtnText}
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default BannerForm;
